import { cn } from "@/lib/utils";
import { DotFilledIcon } from "@radix-ui/react-icons";
import _ from "lodash";
import React from "react";
import { useEffect, useRef, useState } from "react";

interface AutoLayoutSelectorProps {
  selected: number;
  setSelected: (selected: number) => void;
  row?: boolean;
}

const AutoLayoutSelector: React.FC<AutoLayoutSelectorProps> = ({
  selected,
  setSelected,
  row = true,
}) => {
  const [hovered, setHovered] = useState(null);

  const containerRef = useRef<HTMLDivElement>(null);

  const handleMove = (event: WheelEvent) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      setHovered(null);
    }
  };

  const debouncedHandleMove = _.throttle(handleMove, 100);

  useEffect(() => {
    // document.addEventListener('mousemove', debouncedHandleMouseMove);
    document.addEventListener("wheel", debouncedHandleMove);
    return () => {
      // document.removeEventListener('mousemove', debouncedHandleMouseMove);
      document.removeEventListener("wheel", debouncedHandleMove);
    };
  }, [debouncedHandleMove]);

  const LayoutGraphic = ({ index }) => {
    const isSelected = index === selected;
    const isHovered = index === hovered;

    const rowStyles = cn(
      "grow rounded-[1px]",
      isSelected && "bg-icons-primary",
      isHovered
        ? isSelected
          ? "bg-icons-primary"
          : "bg-icons-secondary"
        : undefined
    );

    let alignStyle = "";
    let justifyStyle = "";

    if (row) {
      if (index < 3) {
        alignStyle = "items-start";
      } else if (index < 6) {
        alignStyle = "items-center";
      } else {
        alignStyle = "items-end";
      }
    } else {
      if (index % 3 === 0) {
        alignStyle = "items-start";
      } else if (index % 3 === 1) {
        alignStyle = "items-center";
      } else {
        alignStyle = "items-end";
      }
    }

    if (!isSelected && !isHovered) {
      return (
        <div className="w-1/2 h-2/3 flex justify-center items-center text-text-tertiary">
          <DotFilledIcon className="w-3 h-3" />
        </div>
      );
    }

    return (
      <div
        className={cn(
          "flex h-full w-full gap-0.5 relative",
          row ? "flex-row" : "flex-col",
          alignStyle,
          justifyStyle
        )}
        ref={containerRef}
      >
        <div className={cn(rowStyles, !row ? "w-7/12" : "h-4/6")}></div>

        <div className={cn(rowStyles, !row ? "w-full" : "h-full")}></div>

        <div className={cn(rowStyles, !row ? "w-5/12" : "h-2/6")}></div>
      </div>
    );
  };

  return (
    <div className="w-full aspect-video bg-background-secondary grid grid-cols-3 place-items-center gap-0.5 py-2 rounded-md">
      {Array.from({ length: 9 }).map((_, index) => (
        <div
          key={index}
          // @ts-expect-error TS2345
          onMouseOver={() => setHovered(index)}
          onMouseOut={() => setHovered(null)}
          onClick={() => setSelected(index)}
          className="flex p-0.5 items-center justify-center relative cursor-pointer w-full h-full"
        >
          <div className="h-1/2 w-1/3">
            <LayoutGraphic index={index} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(AutoLayoutSelector);
